import { render, staticRenderFns } from "./wbdp-recharge-config.vue?vue&type=template&id=4c18c679"
import script from "./wbdp-recharge-config.vue?vue&type=script&lang=js"
export * from "./wbdp-recharge-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports